module.exports = "/_next/static/images/circlestar-duotone-3d5ba142bb8a0c5914827a355d053dc3.svg";